<!-- onboarding-slider.component.html -->
<section>
  <div class="onboarding_section">
    <div class="slider-wrapper" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd()">
    <div class="slider-container"
     [style.width]="(slides.length * 100) + 'vw'"
     [style.transform]="'translateX(-' + currentIndex * 100 + 'vw)'">

        <div class="slide" *ngFor="let slide of slides">
          <div class="onbroding_cardf_klk">
            <div class="app_onbroding_section">
              <img [src]="slide.image" alt="Slide Image" class="illustration" />
            </div>
            <div class="content_img_gt">
              <p>{{ slide.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dots">
      <span *ngFor="let slide of slides; let i = index"
            [class.active-dot]="i === currentIndex"
            (click)="goToSlide(i)"></span>
    </div>

    <div class="actions_th_footer getstated" style="margin-top: 60px;">
      <button mat-flat-button class="ft2" (click)="onContinue()">Go to login</button>
    </div>
  </div>
</section>